module.exports = __webpack_public_path__ + "img/josh-prof.6d736dbb.jpg";